export enum Program {
  Chile = 'e06206cd-33e5-4e44-9508-0ed544a21117',
  Costa_Rica = 'bf69a6a6-0595-4001-a017-13e9913a3b64',
  Guatemala = '42bfa2fc-a861-42d2-9b6c-34311464b5db',
  Colombia = 'cc05e840-dacb-4fb7-b536-35a7e71e64e2',
  Venezuela = '7e334afb-1426-45fa-9201-3d3c270279b0',
  Panama = '309701ed-a682-4c1d-bd18-712ffe7acc24',
  Dominicana = 'ef79f351-3cb6-46d1-be6c-7821980a059b',
  Honduras = '5b3f6e6d-7e5f-4c57-a564-afe522a410b4',
  Peru = '7b8e1132-c382-4959-85aa-c5ac90eb9adb',
  Ecuador = 'a7418895-d4a1-4ec4-b9d9-db7403d2a9d9',
}
